import { DeviceIdentificationType, EventTypeEnum } from '@quadminds/shared/tracking-system';
import { IAuditableOutputDto } from './auditable-output-dto.interface';

export interface IEventOutputDto {
    id?: string;
    organizationId?: string;
    event: EventTypeEnum;
    externalId: string;
    identification: {
        type: DeviceIdentificationType;
        value: string;
    };
    latitude: string;
    longitude: string;
    timestamp: string;
    value?: number;
    auditable: IAuditableOutputDto;
    createdAt?: string;
    updatedAt?: string;
    metadata?: Record<string, any>;
    vehicle?: string;
    vehicleLicensePlate?: string;
    vehicleName?: string;
    driver?: string;
    trip?: string;
    zone?: {
        id?: string;
        name?: string;
        code?: string;
    };
    carrier?: {
        id?: string;
        name?: string;
    };
}
